export default {"src":"/_next/static/media/convert.d462681f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};